<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" wrap-class-name="single-spa-vue">
        <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="undefined" name="id">
                    <a-input v-model:value="form.id" placeholder="请输入undefined"/>
                </a-form-item>
            </div>
            <a-form-item label="敏感词" name="content">
                <a-input v-model:value="form.content" placeholder="请输入敏感词"/>
            </a-form-item>
            <!--可编辑区域 end-->
        </a-form>
    </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {sensitive_words} from "@/api/adminService";

export default {
    name: "AddOrEditModal",
    mixins: [formMixin],
    components: {},
    data() {
        return {
            form: {
                content: null,
                id: null,
            },
            rules: {
                content: [
                    dataCheck.required({}),
                ],
                id: [],
            },
            submitUrl: sensitive_words.saveOrUpdate
        }
    },
    methods: {},
}
</script>
<style scoped lang="less">
</style>
